import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  tickets: null,
  messages: null,
  files: null,
  addTicketId: null,
  addMessageStatus: null,
  deleteFileStatus: null,
  closeTicketStatus: null
}

export const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setTickets: (state, action) => { state.tickets = action.payload },
    setMessages: (state, action) => { state.messages = action.payload },
    setFIles: (state, action) => { state.files = action.payload },
    setAddTicketId: (state, action) => { state.addTicketId = action.payload },
    setAddMessageStatus: (state, action) => { state.addMessageStatus = action.payload },
    setDeleteFileStatus: (state, action) => { state.deleteFileStatus = action.payload },
    setCloseTicketStatus: (state, action) => { state.closeTicketStatus = action.payload },

    resetSupport: () => initialState,
  },
})

export const {
  setTickets,
  setMessages,
  setFIles,
  setAddTicketId,
  setAddMessageStatus,
  setDeleteFileStatus,
  setCloseTicketStatus,

  resetSupport
} = supportSlice.actions

export default supportSlice.reducer
